import { bareIzteachClient, getIzteachClient } from '../clients';
import { retryColdStart } from '../core/coldStart';
import { izteachSession, libraryVendorId } from '../session';
import type { IztUnit } from '../types';

export interface IztUnitTitle {
  id?: string;
  _id?: string;
  title?: string | null;
  type?: string | null;
  /** The exam an exercise or test unit wraps. */
  exam?: string | null;
}

export const UnitRepository = {
  // the first open after an idle spell hits the online-course cold start, so it is retried
  fetchOne: (id: string) =>
    retryColdStart(() =>
      getIzteachClient('online')
        .get(`/unit/${id}`, { params: { _populate: 'video' } })
        .then((res) => res.data as IztUnit),
    ),

  // the gateway wants a token, but a denial must not sign the teacher out of IZ, so no recovering client
  titlesForCourse: (courseId: string) => {
    if (!izteachSession.accessToken) return Promise.resolve([] as IztUnitTitle[]);
    return retryColdStart(() =>
      bareIzteachClient('online')
        .get('/unit', {
          // vendorId filters the rows, so the content tenant's; isAdmin only switches on the projection
          params: { vendorId: libraryVendorId(), course: courseId, isAdmin: 1, adminSelects: 'title type exam' },
          headers: { Authorization: izteachSession.accessToken },
        })
        .then((res) => (Array.isArray(res.data) ? res.data as IztUnitTitle[] : [])),
    );
  },
};

export default UnitRepository;
